<template>
  <div id="testimonials">
    <BadgeFilter :slice="slice" :badges="badges" @select="onSelect" />
    <ReviewList :slice="slice" :badges="badges" />
  </div>
</template>

<script>
import { BadgeFilter, ReviewList } from './components'
export default {
  name: 'TestimonialList',
  components: { BadgeFilter, ReviewList },

  props: {
    slice: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      badges: [
        { id: 'google_trustpilot', text: 'Review', isSelected: false },
        { id: 'twitter', text: 'Twitter', isSelected: false },
        { id: 'instagram', text: 'Instagram', isSelected: false },
        { id: 'youtube', text: 'Youtube', isSelected: false },
      ],
    }
  },

  computed: {},

  methods: {
    onSelect({ id }) {
      const badge = this.badges.find((badge) => badge.id === id)
      if (badge) {
        badge.isSelected = !badge.isSelected
      }
    },
  },
}
</script>

<style lang="scss" module></style>
